import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';

import {Toast} from 'primereact/toast';
import moment from 'moment';
import { DATATABLE_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';


class Recipe extends Component {
    state = {
        selectedItems : []
    }
    
    getMenuName = (menuItemId) => {
        if (!this.props.Menuitem || !menuItemId) return menuItemId;
        const MenuItem = this.props.Menuitem.find(item => item.value === menuItemId);
        return MenuItem ? MenuItem.label : menuItemId; // fallback to ID if not found
    }
    menuNameTemplate = (rowData) => {
        return <span>{this.getMenuName(rowData.menuItemId)}</span>;
    }

    dateRender = (rowData) => rowData.effectiveDate ? moment(rowData.effectiveDate).format('DD-MMM-YYYY') : '';
   
    actionTemplate = (rowData) => {

            return <div className="actionCenter">
                {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                    <Link to={"/recipe/edit/"+rowData.recipeId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
                }
                {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                    <Link to={"/recipe/view/"+rowData.recipeId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
                }
            </div>;
    }

    delete= () => {

        if(this.state.selectedItems.length > 0){
            const updatedValue = this.state.selectedItems.map( value => {
                return { DeleteID : value.recipeId};
            })
            this.props.dynamicDeleteProcess('recipe',updatedValue,'res/GeInvRecipeList');
        }
        else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select checkbox'});
        }

    }

    statusRender = (rowData) => {
        let status = <Button type="button" label="In Active" className="p-button-danger p-button-rounded" ></Button>
        if(rowData.isActive === true || rowData.isActive === null){
            status = <Button type="button" label="Active" className="p-button-success p-button-rounded" ></Button>
        }
        return <div className="actionCenter">
                    {status}
               </div>;
    }

    componentDidMount(){        
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        this.props.getMasterKeywordList('Menuitem');
        this.props.getMasterTableList('res/GeInvRecipeList',this.props.loggedUserDetail.CompanyId);    
        // this.props.getMasterTableList('res/GeIngredientBatchList');    
    }
  
    render() {   

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        const header = (
            <div style={{ textAlign: 'right' }}>
                <InputText
                    type="search"
                    onInput={(e) => this.setState({ globalFilter: e.target.value })}
                    placeholder="Search..."
                />
            </div>
        );
        let tableData = [];
        
        
        if(Array.isArray(this.props.tableLists)) {
            tableData = this.props.tableLists.map(item => ({
                ...item,
                menuItemName: this.getMenuName(item.menuItemId)
            }));
        }


        return (
            <div className="p-grid padding">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Recipe Management</h1>
               
                        <div className="p-grid">
                           

                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) && 
                                 <Link to="/recipe/add/new"><Button style={{float: 'right'}} label="Add Recipe" className="ml1"  icon="pi pi-plus"  /></Link>
                                }
                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) && 
                                 <Button  style={{float: 'right'}} onClick={this.delete} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                }

                                </div>                                
                            </div>
                      
                                                    
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                 
                        <DataTable value={tableData} 
                         selection={this.state.selectedItems} onSelectionChange={e => this.setState({selectedItems: e.value})}
                          globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                {/* <Column field="recipeId" header="Recipe ID" sortable={true} /> */}
                                <Column field="menuItemName" header="Menu Item " sortable={true} />
                                {/* <Column field="recipeName" header="Recipe Name"  /> */}
                                <Column field="recipeVersion" header="Version"  />
                                <Column body={this.dateRender} header="Effective Date"  />
                                {/* <Column field="isActive" header="STATUS" body={this.statusRender} sortable={true} /> */}
                                <Column field="action" body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
        Menuitem: state.keyword.Menuitem,
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table,companyid) => dispatch(actions.getMasterTableList(table,companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(Recipe);